/**
 * Applies accessibility + visual preferences to the document root so the
 * whole UI reacts live. Classes:
 *   • a11y-high-contrast, a11y-reduce-motion, a11y-reduce-effects, a11y-use-shapes
 *   • a11y-text-sm / a11y-text-md / a11y-text-lg
 *   • a11y-cb-none / a11y-cb-protanopia / a11y-cb-deuteranopia / a11y-cb-tritanopia
 *
 * The corresponding CSS lives in `/app/frontend/src/index.css`.
 */
export function applyAccessibility(preferences) {
  const root = document.documentElement;
  const a11y = (preferences || {}).accessibility || {};
  const vfx = (preferences || {}).visual_effects || {};
  const cb = a11y.color_blind_mode || "none";
  const ts = a11y.text_size || "md";

  root.classList.toggle("a11y-high-contrast", !!a11y.high_contrast);
  // Reduced motion accepted from either the a11y key OR the legacy vfx key.
  root.classList.toggle("a11y-reduce-motion",
    !!a11y.reduce_motion || !!vfx.reduced_motion);
  root.classList.toggle("a11y-reduce-effects", !!a11y.reduce_effects);
  root.classList.toggle("a11y-use-shapes", !!a11y.use_shapes);

  for (const s of ["sm", "md", "lg"]) {
    root.classList.toggle(`a11y-text-${s}`, ts === s);
  }
  for (const m of ["none", "protanopia", "deuteranopia", "tritanopia"]) {
    root.classList.toggle(`a11y-cb-${m}`, cb === m);
  }
}
